import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ada30b0")

_pushScopeId("data-v-4ada30b0")
const _hoisted_1 = { id: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Solutions")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Products")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Company")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode(_component_GridLine, { class: "hide2 hide3 hide4 hide5" }),
    _createVNode(_component_router_link, {
      class: "logo",
      to: "/"
    }),
    _createVNode("nav", {
      class: {'active': _ctx.menuOpen}
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuOpen = false))
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/solutions",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuOpen = false))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/products",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.menuOpen = false))
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/company",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuOpen = false))
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/contact",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuOpen = false))
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ], 2),
    _createVNode("div", {
      class: ["mobile-menu-btn", {'active': _ctx.menuOpen}],
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, [
      _hoisted_7
    ], 2)
  ]))
})